var siteMap = {
    'app.ageras.com': 'secure.zervant.com',
    'app.staging.ageras.com': 'invoicing.staging.shine.co',
    'app.shine.co': 'login.shine.co',
    'app.staging.shine.co': 'login.staging.shine.co'
}

function getCurrentSite() {
    return window.location.hostname
}

function getRedirectHost() {
    var currentSite = getCurrentSite()
    return siteMap[currentSite]
}

module.exports = {
    getLoginRedirectUrl: function() {
        var redirectHost = getRedirectHost()

        if (!redirectHost) {
            return null
        }

        return 'https://' + redirectHost + '/login/login'
    },

    getSignupRedirectUrl: function() {
        var redirectHost = getRedirectHost()

        if (!redirectHost) {
            return null
        }

        return 'https://' + redirectHost + '/login/signup'
    },

    getShineAuthCookieDomain: function() {
        var currentSite = getCurrentSite()

        if (siteMap[currentSite] === undefined) {
            return null
        }

        return currentSite.split('.').slice(1).join('.')
    }
}
